import {connect} from 'react-redux';
import React, {Component} from 'react';

import Info from '../Info';
import Owner from '../Owner';
import Location from '../Location';
import Description from '../Description';
import * as ObjectUtils from '../../../utils/Property';
import * as ObjectConst from '../../../constants/Property';
import * as ConfigurationUtils from '../../../utils/Configuration';

import viewsSVG from '../../../static/img/objects/other/views.svg';
import kitchenSVG from '../../../static/img/objects/other/kitchen.svg';
import furnitureSVG from '../../../static/img/objects/other/furniture.svg';
import poolSVG from '../../../static/img/objects/characteristics/pool.svg';
import refSVG from '../../../static/img/objects/generalInformation/ref.svg';
import floorSVG from '../../../static/img/objects/characteristics/floor.svg';
import areaSVG from '../../../static/img/objects/generalInformation/area.svg';
import garageSVG from '../../../static/img/objects/characteristics/garage.svg';
import gardenSVG from '../../../static/img/objects/characteristics/garden.svg';
import ourExclusiveSVG from '../../../static/img/objects/other/ourExclusive.svg';
import terraceSVG from '../../../static/img/objects/generalInformation/terrace.svg';
import typeConditionsSVG from '../../../static/img/objects/other/typeConditions.svg';
import lifestyleSVG from '../../../static/img/objects/characteristics/lifestyle.svg';
import countBedsSVG from '../../../static/img/objects/generalInformation/countBeds.svg';
import typeOrientationsSVG from '../../../static/img/objects/other/typeOrientations.svg';
import typeApartmentSVG from '../../../static/img/objects/generalInformation/typeApartment.svg';
import countBedroomsSVG from '../../../static/img/objects/generalInformation/countBedrooms.svg';
import countBathroomsSVG from '../../../static/img/objects/generalInformation/countBathrooms.svg';
import yearOfConstructionSVG from '../../../static/img/objects/characteristics/yearOfConstruction.svg';

class MainContainer extends Component {
    getGeneralInformationInfo() {
        const {i18n} = this.props;
        const props = this.props.objectPage.currentObject.props;
        let info = {
            title: i18n['objectPage.generalInformation'],
            items: []
        };


        let objectId = this.props.objectPage.currentObject.id;
        let item = {
            imgURL: refSVG,
            name: i18n['objectPage.ref'],
            value: "Ref. " + objectId.substr(objectId.length - 7)
        };
        info.items.push(item);

        if (props.typeApartment !== undefined && props.typeApartment !== null && props.typeApartment.length > 0) {
            let item = {
                imgURL: typeApartmentSVG,
                name: i18n['objectPage.typeApartment'],
                value: ConfigurationUtils.getTypeTitleByValue(props.typeApartment, this.props.configuration.object.typeApartmentsSell)
            };
            info.items.push(item);
        }
        if (props.area !== undefined && props.area !== null && props.area > 0) {
            let item = {
                imgURL: areaSVG,
                name: i18n['objectPage.area'],
                value: `${props.area} ${i18n['objectPage.areaUnit']}`
            };
            info.items.push(item);
        }
        if (props.terrace !== undefined && props.terrace !== null && props.terrace > 0) {
            let item = {
                imgURL: terraceSVG,
                name: i18n['objectPage.terrace'],
                value: `${props.terrace} ${i18n['objectPage.areaUnit']}`
            };
            info.items.push(item);
        }
        if (props.countBeds !== undefined && props.countBeds !== null && props.countBeds > 0) {
            let item = {
                imgURL: countBedsSVG,
                name: i18n['objectPage.countBeds'],
                value: props.countBeds
            };
            info.items.push(item);
        }
        if (props.countBedrooms !== undefined && props.countBedrooms !== null && props.countBedrooms > 0) {
            let item = {
                imgURL: countBedroomsSVG,
                name: i18n['objectPage.countBedrooms'],
                value: props.countBedrooms
            };
            info.items.push(item);
        }
        if (props.countBathrooms !== undefined && props.countBathrooms !== null && props.countBathrooms > 0) {
            let item = {
                imgURL: countBathroomsSVG,
                name: i18n['objectPage.countBathrooms'],
                value: props.countBathrooms
            };
            info.items.push(item);
        }
        return info;
    }

    getOtherInfo = () => {
        const {
            i18n,
            configuration: {
                object: {
                    viewsValues,
                    kitchenValues,
                    // newTypeValues,
                    conditionValues,
                    orientationValues
                }
            },
            objectPage: {
                currentObject: {
                    props: {
                        rangeType
                    },
                    other: {
                        views,
                        kitchen,
                        // newType,
                        condition,
                        orientation
                    },
                    amenities: {
                        easeFurniture
                    }
                }
            }
        } = this.props;

        return {
            title: i18n['objectPage.other'],
            items: [
                {
                    imgURL: typeOrientationsSVG,
                    name: i18n['objectPage.typeOrientations'],
                    value: ConfigurationUtils.getTypeTitleByValue(orientation, orientationValues)
                },
                {
                    imgURL: viewsSVG,
                    name: i18n['objectPage.views'],
                    value: ConfigurationUtils.getTypeTitleByValue(views, viewsValues)
                },
                {
                    imgURL: typeConditionsSVG,
                    name: i18n['objectPage.typeConditions'],
                    value: ConfigurationUtils.getTypeTitleByValue(condition, conditionValues)
                },
                {
                    imgURL: ourExclusiveSVG,
                    name: i18n['objectPage.rangeType'],
                    value: rangeType === ObjectConst.RANGE_TYPE.EXCLUSIVE ? i18n['objectPage.yes'] : i18n['objectPage.no']
                },
                {
                    imgURL: furnitureSVG,
                    name: i18n['objectPage.furniture'],
                    value: easeFurniture ? i18n['objectPage.yes'] : i18n['objectPage.no']
                },
                {
                    imgURL: kitchenSVG,
                    name: i18n['objectPage.kitchen'],
                    value: ConfigurationUtils.getTypeTitleByValue(kitchen, kitchenValues)
                }
            ]
        };
    };

    getCharacteristicsInfo = () => {
        const {
            i18n,
            configuration: {
                object: {
                    poolValues,
                    lifestyles,
                    floorValues,
                    garageValues,
                    gardenValues
                }
            },
            objectPage: {
                currentObject: {
                    characteristics: {
                        pool,
                        floor,
                        garage,
                        garden,
                        lifestyle,
                        yearOfConstruction
                    }
                }
            }
        } = this.props;

        return {
            title: i18n['objectPage.characteristics'],
            items: [
                {
                    imgURL: lifestyleSVG,
                    name: i18n['objectPage.lifestyle'],
                    value: ConfigurationUtils.getTypeTitleByValue(lifestyle, lifestyles)
                },
                {
                    imgURL: poolSVG,
                    name: i18n['objectPage.pool'],
                    value: ConfigurationUtils.getTypeTitleByValue(pool, poolValues)
                },
                {
                    imgURL: garageSVG,
                    name: i18n['objectPage.garage'],
                    value: ConfigurationUtils.getTypeTitleByValue(garage, garageValues)
                },
                {
                    imgURL: gardenSVG,
                    name: i18n['objectPage.guard'],
                    value: ConfigurationUtils.getTypeTitleByValue(garden, gardenValues)
                },
                {
                    imgURL: floorSVG,
                    name: i18n['objectPage.floor'],
                    value: ConfigurationUtils.getTypeTitleByValue(floor, floorValues)
                },
                {
                    value: yearOfConstruction,
                    imgURL: yearOfConstructionSVG,
                    name: i18n['objectPage.yearOfConstruction']
                }
            ]
        };
    };

    getRentComment() {
        const {code, translates, isShowOriginal, rentComment} = this.props;
        let response;

        if (translates !== undefined && translates !== null && code !== undefined) {
            if (isShowOriginal) {
                response = rentComment;
            } else {
                response = ObjectUtils.getTranslateByCode(translates, code).rentComment;
            }
        }
        if (rentComment !== undefined && rentComment !== null) {
            response = rentComment;
        } else {
            response = '';
        }
        return response;
    }

    render() {
        const {i18n} = this.props;

        return (
            <div className="main-container">
                <Owner/>

                <div className="rent-nav">
                    <a href="#description" className="active">
                        <svg xmlns="http://www.w3.org/2000/svg" width="55" height="54" viewBox="0 0 55 54">
                            <path fill="#ccc"
                                  d="M45.34 22L55 16.51 27.5.99 0 16.51 9.66 22 0 27.45l9.66 5.49L0 38.39 27.5 54 55 38.39l-9.66-5.45L55 27.45zM27.5 3.28l23.45 13.24L27.5 29.83 4.05 16.52zM11.7 23.15l15.81 8.97 15.82-8.97 7.63 4.31L27.5 40.77 4.05 27.46zM50.95 38.4L27.5 51.71 4.05 38.4l7.64-4.31 15.81 8.98 15.82-8.98z"/>
                        </svg>
                        <span>{i18n['objectPage.overview']}</span>
                    </a>
                    <a href="#characteristics">
                        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
                            <path fill="#ccc"
                                  d="M48.98 0H1.02C.46 0 0 .46 0 1.02v47.96C0 49.54.46 50 1.02 50h40.77c.56 0 1.02-.46 1.02-1.02s-.46-1.01-1.02-1.01H2.04V2.03h45.93v46.95c0 .56.45 1.02 1.01 1.02S50 49.54 50 48.98V1.02C50 .46 49.54 0 48.98 0zM11.16 10.59a3.9 3.9 0 1 0 .01 7.8 3.9 3.9 0 0 0 0-7.8zm0 5.76a1.87 1.87 0 0 1 0-3.73 1.87 1.87 0 0 1 0 3.73zm30.7-2.88H18.1a1.01 1.01 0 1 0 0 2.03h23.75a1.01 1.01 0 1 0 0-2.03zm-30.7 7.63c-.56 0-1.02.46-1.02 1.02s.46 1.01 1.02 1.01a1.87 1.87 0 0 1 0 3.74A1.87 1.87 0 0 1 9.3 25a1.02 1.02 0 0 0-2.03 0 3.9 3.9 0 1 0 3.9-3.9zm30.7 2.88H18.1a1.02 1.02 0 0 0 0 2.04h23.75a1.02 1.02 0 0 0 0-2.04zm-30.7 7.63a3.9 3.9 0 1 0 .01 7.8 3.9 3.9 0 0 0 0-7.8zm0 5.77a1.87 1.87 0 1 1 1.87-1.87c0 1.03-.84 1.87-1.87 1.87zm30.7-2.88H18.1a1.01 1.01 0 1 0 0 2.03h23.75a1.01 1.01 0 1 0 0-2.03z"/>
                        </svg>
                        <span>{i18n['objectPage.characteristics']}</span>
                    </a>
                    <a href="#location">
                        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="47" viewBox="0 0 34 47">
                            <path fill="#ccc"
                                  d="M17.65 10.3a6.03 6.03 0 0 0-6.02 6.01 6.03 6.03 0 0 0 12.05 0c0-3.31-2.7-6.01-6.03-6.01zm0 10.3a4.3 4.3 0 1 1 0-8.6 4.3 4.3 0 0 1 0 8.6zM29.17 4.82A16.45 16.45 0 0 0 17.5 0C13.1 0 8.95 1.72 5.83 4.82.06 10.58-.65 21.4 4.28 27.95L17.5 47l13.2-19.02c4.95-6.58 4.23-17.4-1.53-23.16zm.13 22.16l-11.8 17L5.68 26.95C1.2 21 1.85 11.23 7.05 6.04c2.8-2.79 6.5-4.32 10.45-4.32 3.95 0 7.66 1.53 10.45 4.32 5.2 5.19 5.85 14.96 1.35 20.94z"/>
                        </svg>
                        <span>{i18n['objectPage.location']}</span>
                    </a>
                </div>

                <Description/>

                <div className="separator-dashed"/>

                {this.props.configuration.object.typeApartmentsSell.length > 0 &&
                <Info keyPrefix="generalInformation" info={::this.getGeneralInformationInfo()}/>}

                <Info keyPrefix="other" info={this.getOtherInfo()}/>

                <Info keyPrefix="characteristics" idValue="characteristics" info={this.getCharacteristicsInfo()}/>

                <div className="separator-dashed"/>

                <div className="rent-comment">
                    <h2>{i18n['objectPage.comment']}</h2>
                    <div className="rent-comment-content">
                        {this.getRentComment()}
                    </div>
                </div>

                <div className="separator-dashed double"/>

                <Location/>

                <div className="separator-dashed double"/>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    objectPage: state.objectPage,
    configuration: state.configuration,
    code: state.languages.currentLanguage.code,
    isShowOriginal: state.objectPage.isShowOriginal,
    translates: state.objectPage.currentObject.meta.translates,
    rentComment: state.objectPage.currentObject.description.rentComment
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(MainContainer);



// WEBPACK FOOTER //
// ./src/components/PropertyPage/Buy/MainContainer.js